/* receives a masked phoneNumber (111) 111-1111 and returns 1111111111; */
const unmaskPhoneNumber = (maskedNumber) => maskedNumber.replace(/\D/g, '');

/* receives a date as string, such as 2024-08-07T13:57:08.572Z and converts into 08/07/2024 */
const toLocaleDateString = (dateString) => {
  const dateToParse = new Date(dateString);
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  };
  return dateToParse.toLocaleDateString('en-US', options);
};

const formatDate = (dates) => {
  if (dates !== null) {
    const day1 = new Date(dates);
    return `${day1.toLocaleString('en-US', { month: 'long' })} ${day1.getDate()}`;
  }
  return 'undefined';
};

const formatDate2 = (d) => {
  const date = new Date(d);
  const year = date.getFullYear();
  const month = (1 + date.getMonth()).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${month}/${day}/${year}`;
};

const formatTime = (dateTime) => {
  const date = new Date(dateTime);
  const hours = date.getHours();
  const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
  const meridiem = hours >= 12 ? 'PM' : 'AM';
  return `${hours > 12 ? hours - 12 : hours}:${minutes} ${meridiem}`;
};

export {
  unmaskPhoneNumber,
  toLocaleDateString,
  formatDate,
  formatDate2,
  formatTime,
};
